import moment from "moment";

import "./print.css";

// hooks
import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router";
import usePlans from "../../common/apollo/hooks/usePlans";

// components
import { Button, Grid } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import Loader from "../../common/loader/Loader";
import Error from "../../common/error/Error";
import WeekTable from "./WeekTable";

const PrintPlan = (_props) => {
  const { from, to } = useParams();
  const history = useHistory();

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    if (from) setFromDate(moment(from).toDate());
    if (to) setToDate(moment(to).toDate());
  }, [from, to]);

  const { data: plans = [], error, loading } = usePlans(fromDate, toDate);

  const canShow = fromDate && toDate;

  const print = {};
  plans.forEach((plan) => {
    const date = moment(plan.date);

    const w = date.format("w");
    if (!print[w]) print[w] = {};

    const mTime = parseInt(date.format("H"));
    let m = plan.meal;
    if (m === "uzina") m += mTime > 12 ? "2" : "1";
    if (!print[w][m]) print[w][m] = {};

    const d = date.format("ddd");
    if (!print[w][m][d]) print[w][m][d] = [];

    print[w][m][d].push(plan);
  });

  return (
    <>
      {canShow && (
        <Grid container className="print">
          {loading && <Loader />}
          {error && <Error message={error} />}
          {!loading && !error && (
            <>
              <Grid item xs={12} className="no-print toolbar">
                <Button onClick={() => history.goBack()}>Nazad</Button>
                <Button
                  startIcon={<PrintIcon />}
                  onClick={() => window.print()}
                >
                  Štampa
                </Button>
              </Grid>
              {Object.keys(print).map((w) => (
                <WeekTable key={`week-${w}`} week={w} data={print[w]} />
              ))}
            </>
          )}
        </Grid>
      )}
    </>
  );
};

export default PrintPlan;
